import React, { FC, useEffect, useState, useContext } from 'react'
import moment from 'moment'
import AppContext from '../../../context/appContext'
import history from '../../../history'
import { isMobile } from 'react-device-detect'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import UserQueueIcon from '../../../assets/REDESIGN_Assets/Conferences/room-users-queue.svg'

import {
  ConferencesScreenContainer,
  TestRoomButton,
  LeaveRoomBackBanner,
  BannerButton,
  QueueInfoBanner,
  QueueBannerHeader,
  QueueBannerInfoValue,
  QueueBannerRow,
  QueueBannerInfoText,
  ErrorTextArea,
  ButtonContainer,
  VideoTile,
} from '../styles/ConferencesScreenStyles'
import { CloseButton } from '../../MainScreen/subComponents/DropdownMenu.jsx'
import prettyMilliseconds from 'pretty-ms'

import { obtainFolderVideos } from '../../../Api/base'
import VideosView from './VideosView'
import QueueView from './QueueView'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import cookie from 'react-cookies'
import { useSelector } from 'react-redux'
import { getFolders, getUserData } from '../../../Api/backendApi'
import { getAllAlbumVideos } from '../../../Api/videoApi'

import { chimeReportConferenceBug } from '../../../Api/ChimeApi'

import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../../NavigationBar/NavigationBar'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import TimeIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/time-icon.svg'
import RoomIcon from '../../../assets/REDESIGN_Assets/Conferences/room-icon.svg'

import MainpageCarousel from '../../MainScreen/views/MainpageCarousel'
import { albumType } from '../../../utils/albumCategories'
import GenericButton from '../../../GenericComponents/GenericButton'

// interface iQueueRoom {
//   Object: Object
// }
// interface iQueueVideo {
//   video_1: iQueueRoom,
//   video_2:
// }
// export interface iQueueFolder {
//   any
// }

interface MainViewViewProps {
  redirectUserToConferenceRoom: Function
  handleUserJoinQueue: Function
  conference: any
  isUserInQueue: boolean
  userQueuedRoomKey: any
  handleUserleaveQueue: Function
  getQueuedUsers: Function
  isRoomCreated: boolean
  isUserKicked: boolean
  isUserKickedBackend: boolean
  meeting: any
  attendee: any
  seletedMiazgaFolder: any
  setSelectedVideo: Function
  selectedVideoId: number
  selectedVideo: any
  isSessionQueueOpen: any
  isFirstQueueOpen: any
  isSecondQueueOpen: any
  handleUserBackToRoom: Function
  hideReturnToRoomBanner: boolean
  userQueuedMiazgaId: number
  userQueuedVideoId: number
  handleUserBackToCorrectQueue: Function
  showBackToCorrectQueueBanner: boolean
  msToPushUserFromFirstQueue: any
  shouldQueueBeOpen: boolean
  redirectUserTimeCounter: any
  shouldUserBePushedToVideo: boolean
  userQueueInfo: any
}

const MainView: FC<MainViewViewProps> = ({
  redirectUserToConferenceRoom,
  handleUserJoinQueue,
  conference,
  isUserInQueue,
  userQueuedRoomKey,
  handleUserleaveQueue,
  getQueuedUsers,
  isRoomCreated,
  isUserKicked,
  isUserKickedBackend,
  meeting,
  attendee,
  seletedMiazgaFolder,
  setSelectedVideo,
  selectedVideoId,
  selectedVideo,
  isSessionQueueOpen,
  isFirstQueueOpen,
  isSecondQueueOpen,
  handleUserBackToRoom,
  hideReturnToRoomBanner,
  userQueuedMiazgaId,
  userQueuedVideoId,
  handleUserBackToCorrectQueue,
  showBackToCorrectQueueBanner,
  msToPushUserFromFirstQueue,
  shouldQueueBeOpen,
  redirectUserTimeCounter,
  shouldUserBePushedToVideo,
  userQueueInfo,
}) => {
  const appContext = useContext(AppContext)
  const [videos, setVideos] = useState(Object)
  const [user, setUser] = useState(Object)
  const { promiseInProgress } = usePromiseTracker()

  const [queueVideoName, setQueueVideoName] = useState('')
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [userReportErrorMessage, setUserReportErrorMessage] = useState('')

  // const getVideos = async () => {
  //   const allAlbumVids: any = await obtainFolderVideos(seletedMiazgaFolder.path)

  //   // await allAlbumVids.sort((a, b) => a.name - b.name)
  //   await setVideos(allAlbumVids)
  // }

  useEffect(() => {
    obtainUser()
  }, [])

  useEffect(() => {
    if (seletedMiazgaFolder && seletedMiazgaFolder.albumVimeoId) {
      obtainVideos(seletedMiazgaFolder.albumVimeoId)
    }
  }, [seletedMiazgaFolder])

  const obtainVideos = async (videoId: number) => {
    let videos = await getAllAlbumVideos(videoId)
    setVideos(videos)
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await trackPromise(getUserData())
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const toggleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }

  const handleSendBugReport = () => {
    chimeReportConferenceBug(userReportErrorMessage)
    setOpenErrorModal(false)
  }

  const formatQueueUsers = (roomKey: number) => {
    let users: any = []
    let usersString: string = ''

    if (conference.rooms[roomKey].users) {
      for (const key of Object.keys(conference.rooms[roomKey].users)) {
        // users[...users,conference.rooms[roomKey].users[key]]

        if (conference.rooms[roomKey].users[key].user_name) {
          users.push(conference.rooms[roomKey].users[key].user_name)
        }
      }
    }

    if (users) {
      users.forEach((user: any, i: any) => {
        if (i === users.length - 1) {
          usersString += `${user}`
        } else {
          usersString += ` ${user} / `
        }
      })
    }

    return usersString
  }

  return (
    <>
      <GenericBackgroundLayer
        justify={'flex-start'}
        className={`${
          appContext.appState.theme == 'light' ? 'light' : 'standard'
        } mainpage`}
      >
        <NavigationBar
          isPlayerView={false}
          backButtonAction={() => history.push('/trening')}
        />
        <GenericRow
          padding={isMobile ? '10px' : 'unset'}
          wrap={isMobile ? 'wrap' : 'unset'}
          margin={'1% auto'}
          width={isMobile ? '100%' : '85%'}
          justify={'flex-start'}
          className="main-view-container"
        >
          <GenericColumn width={isMobile ? '100%' : '30%'}>
            <GenericRow justify={'flex-start'}>
              <GenericTextSpan
                fSize={'2rem'}
                margin={'5vh 0 1% 0%'}
                tAlign={'left'}
                display={'block'}
                className={`${
                  appContext.appState.theme == 'light' ? 'light' : ''
                }`}
              >
                Cześć {user && user.name}
              </GenericTextSpan>
            </GenericRow>
            <GenericRow justify={'flex-start'}>
              <GenericTextSpan
                opacity={'0.7'}
                display={'block'}
                margin={'2% 0 1% 0%'}
                className={`${
                  appContext.appState.theme == 'light' ? 'light' : ''
                }`}
              >
                Super, że jesteś
              </GenericTextSpan>
            </GenericRow>
          </GenericColumn>
        </GenericRow>

        <GenericRow
          width={isMobile ? '100%' : '85%'}
          margin={'2vh auto 0 auto'}
          align={'flex-start'}
          justify={'space-between'}
        >
          {/* Left row with videos */}
          <GenericColumn width={'55%'}>
            <GenericRow justify="flex-start" margin={'5% 0 0 0'}>
              <GenericTextSpan justifu>
                Wybierz trening który chcesz zrobić wspólnie
              </GenericTextSpan>
            </GenericRow>

            <GenericRow justify={'flex-start'} margin={'4vh 0 0 0'}>
              {videos && videos.video_for_today && (
                <GenericColumn
                  onClick={() => setSelectedVideo(videos.video_for_today)}
                  width={'50%'}
                >
                  <GenericRow justify={'flex-start'}>
                    <GenericTextSpan justifu>Trening na dziś</GenericTextSpan>
                  </GenericRow>
                  <GenericRow justify={'flex-start'}>
                    <VideoTile className="not-carousel-item">
                      <GenericColumn
                        width={'26%'}
                        height={'96%'}
                        margin={'0 0 0 4%'}
                      >
                        <GenericIcon
                          backgroundSize={'cover'}
                          width={'100%'}
                          height={'80%'}
                          borderRadius={'19px'}
                          src={
                            videos &&
                            videos.video_for_today.pictures.sizes[3].link
                          }
                        ></GenericIcon>
                      </GenericColumn>
                      <GenericColumn
                        width={'70%'}
                        height={'100%'}
                        justify="space-between"
                        padding={'5%'}
                      >
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'0.8rem'}>
                            Trening na dziś
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'1.1rem'} fWeight={'bold'}>
                            {videos &&
                              videos.video_for_today &&
                              videos.video_for_today.name}
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericIcon
                            margin={'0 5px 0 0'}
                            width={'0.8rem'}
                            height={'0.8rem'}
                            src={TimeIcon}
                          ></GenericIcon>
                          <GenericTextSpan fSize={'0.9rem'}>
                            {videos &&
                              videos.video_for_today &&
                              Math.floor(videos.video_for_today.duration / 60) +
                                'minut'}
                          </GenericTextSpan>
                        </GenericRow>
                      </GenericColumn>
                    </VideoTile>
                  </GenericRow>
                </GenericColumn>
              )}

              {videos && videos.video_for_next_day && (
                <GenericColumn width={'50%'} right={'10px'}>
                  <GenericTextSpan>Trening na kolejny dzień</GenericTextSpan>
                  <GenericRow justify="flex-start">
                    <VideoTile className="not-carousel-item inactive">
                      <GenericColumn
                        width={'26%'}
                        height={'96%'}
                        margin={'0 0 0 4%'}
                      >
                        <GenericIcon
                          backgroundSize={'cover'}
                          width={'100%'}
                          height={'80%'}
                          borderRadius={'19px'}
                          src={
                            videos &&
                            videos.video_for_next_day.pictures.sizes[3].link
                          }
                        ></GenericIcon>
                      </GenericColumn>
                      <GenericColumn
                        width={'70%'}
                        height={'100%'}
                        justify="space-between"
                        padding={'5%'}
                      >
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'0.8rem'}></GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'1.1rem'} fWeight={'bold'}>
                            {videos &&
                              videos.video_for_next_day &&
                              videos.video_for_next_day.name}
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericIcon
                            margin={'0 5px 0 0'}
                            width={'0.8rem'}
                            height={'0.8rem'}
                            src={TimeIcon}
                          ></GenericIcon>
                          <GenericTextSpan fSize={'0.9rem'}>
                            {videos &&
                              videos.video_for_next_day &&
                              Math.floor(
                                videos.video_for_next_day.duration / 60
                              ) + 'minut'}
                          </GenericTextSpan>
                        </GenericRow>
                      </GenericColumn>
                    </VideoTile>
                  </GenericRow>
                </GenericColumn>
              )}
            </GenericRow>

            <GenericRow>
              {videos.videos && videos.videos.length && (
                <MainpageCarousel
                  setDemoUserRedirectToSubModalOpen={null}
                  fullWidth={true}
                  onClick={setSelectedVideo}
                  isConferences={true}
                  // ref={carousel6Ref}
                  isDemoMode={false}
                  folders={videos.videos && videos.videos}
                  albumType={'wspolne-treningi'}
                  albumName={albumType.treningiMiazga.label}
                  categoryTag={albumType.treningiMiazga.tag}
                  conferencesTrainings={true}
                ></MainpageCarousel>
              )}
            </GenericRow>
          </GenericColumn>
          {/* right row with queue */}
          <GenericColumn width={'37%'}>
            <QueueView
              conference={conference}
              handleUserJoinQueue={handleUserJoinQueue}
              isUserInQueue={isUserInQueue}
              userQueuedRoomKey={userQueuedRoomKey}
              handleUserleaveQueue={handleUserleaveQueue}
              getQueuedUsers={getQueuedUsers}
              isRoomCreated={isRoomCreated}
              redirectUserToConferenceRoom={redirectUserToConferenceRoom}
              isUserKicked={isUserKicked}
              isUserKickedBackend={isUserKickedBackend}
              meeting={meeting}
              attendee={attendee}
              seletedMiazgaFolder={seletedMiazgaFolder}
              selectedVideoId={selectedVideoId}
              selectedVideo={selectedVideo}
              isSessionQueueOpen={isSessionQueueOpen}
              isFirstQueueOpen={isFirstQueueOpen}
              isSecondQueueOpen={isSecondQueueOpen}
              shouldQueueBeOpen={shouldQueueBeOpen}
            />
          </GenericColumn>
        </GenericRow>
      </GenericBackgroundLayer>

      <ConferencesScreenContainer className="flex-row conferences-main">
        {isUserInQueue && shouldQueueBeOpen ? (
          <QueueInfoBanner>
            <GenericRow>
              <GenericTextSpan fSize={'2rem'} margin={'5% 0 8% 0'}>
                Jesteś obecnie w kolejce do treningu
              </GenericTextSpan>
            </GenericRow>

            <GenericColumn
              width={'80%'}
              padding={'20px'}
              margin={'0 auto'}
              className="opacity-background"
            >
              <GenericRow width={'90%'}>
                <GenericColumn width={'33%'}>
                  <GenericRow justify="left">
                    <GenericTextSpan fSize={'1.1rem'} fWeight="bold">
                      {selectedVideo && selectedVideo.name}
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
                <GenericColumn width={'33%'}>
                  <GenericRow>
                    <GenericIcon
                      src={UserQueueIcon}
                      width={'1vw'}
                      height="1vw"
                    ></GenericIcon>
                    <GenericTextSpan fSize={'1.1rem'}>
                      {userQueueInfo && Object.keys(userQueueInfo.users).length}{' '}
                      /6
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
                <GenericColumn width={'33%'}>
                  <GenericRow justify="right">
                    <GenericIcon
                      src={RoomIcon}
                      width={'1vw'}
                      height="1vw"
                    ></GenericIcon>
                    <GenericTextSpan fSize={'1.1rem'}>
                      Pokój
                      {userQueuedRoomKey % 5 == 0 ? '5' : userQueuedRoomKey % 5}
                    </GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
              </GenericRow>

              <GenericRow
                margin={'4% 0 2% 0'}
                padding={'5px 0 15px 0'}
                width={'90%'}
                className="border-bottom"
                justify={'left'}
              >
                <GenericTextSpan fSize={'1.1rem'}>
                  {formatQueueUsers(userQueuedRoomKey)}
                </GenericTextSpan>
              </GenericRow>

              <GenericRow margin={'2% 0 0 0%'}>
                <GenericColumn margin={'2% 0 0 0%'} width={'50%'}>
                  <GenericRow justify={'flex-end'}>
                    <GenericTextSpan>{`otwarcie kolejki ${moment(
                      conference.sessions[0].start_date
                    ).format('HH:mm')}`}</GenericTextSpan>
                  </GenericRow>
                  <GenericRow margin={'4% 0 0 0%'} justify={'flex-end'}>
                    <GenericTextSpan>{`zamknięcie kolejki ${moment(
                      conference.sessions[0].redirect_users_date
                    ).format('HH:mm')}`}</GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
                <GenericColumn
                  margin={'2% 0 0 0%'}
                  width={'50%'}
                  height={'100%'}
                >
                  <GenericRow>
                    <GenericTextSpan>{`start ${moment(
                      conference.sessions[0].start_video
                    ).format('HH:mm')}`}</GenericTextSpan>
                  </GenericRow>
                </GenericColumn>
              </GenericRow>
            </GenericColumn>

            <GenericRow margin={'6% 0 0 0%'}>
              <GenericTextSpan fSize={'1.6rem'}>
                Przekierowanie do treningu LIVE nastąpi za:
              </GenericTextSpan>
            </GenericRow>

            <GenericRow margin={'6% 0 0 0%'}>
              <GenericTextSpan fSize={'4rem'}>
                {redirectUserTimeCounter.minutesToEndQueue +
                  ':' +
                  (redirectUserTimeCounter.secondsToEndQueue < 10
                    ? `0${redirectUserTimeCounter.secondsToEndQueue}`
                    : redirectUserTimeCounter.secondsToEndQueue)}
              </GenericTextSpan>
            </GenericRow>

            <GenericRow margin={'3% 0 0 0%'}>
              <GenericTextSpan fSize={'1.3rem'}>
                Upewnij się, że masz działający mikrofon oraz kamerę.
              </GenericTextSpan>
            </GenericRow>

            <GenericRow margin={'3% 0 0 0%'}>
              <GenericTextSpan fSize={'1.3rem'}>
                Nie wychodź z kolejki do czasu przekierowania do treningu.
              </GenericTextSpan>
            </GenericRow>

            <GenericButton
              width={'50%'}
              margin={'8% 25%'}
              justify={'center'}
              className="standard"
              onClick={() => handleUserleaveQueue(userQueuedRoomKey)}
            >
              Wyjdź z kolejki
            </GenericButton>
          </QueueInfoBanner>
        ) : isUserInQueue && !shouldQueueBeOpen ? (
          <GenericColumn
            width={'80%'}
            padding={'20px'}
            margin={'0 auto'}
            className="opacity-background"
          >
            <GenericRow>
              <GenericTextSpan>
                Niestety, ale byłaś jedyna w kolejce, więc pokój nie został
                utworzony.
              </GenericTextSpan>
            </GenericRow>
            <GenericRow>
              <GenericButton
                onClick={() => handleUserleaveQueue(userQueuedRoomKey)}
              >
                Wróć
              </GenericButton>
            </GenericRow>
          </GenericColumn>
        ) : null}

        {/* <VideosView
          seletedMiazgaFolder={seletedMiazgaFolder}
          setSelectedVideo={setSelectedVideo}
          selectedVideo={selectedVideo}
        /> */}

        {/* {openErrorModal && (
          <QueueInfoBanner className="alternative error">
            <CloseButton
              onClick={() => setOpenErrorModal(false)}
              top="3%"
              right="1%"
            />
            <QueueBannerInfoValue className="alternative color-white">
              Zgłoś błąd lub problem
            </QueueBannerInfoValue>
            <QueueBannerInfoText className="alternative color-white">
              Zgłoś błąd lub problem, abyśmy mogli poprawić Twoje odczucia
              korzystania z treningów LIVE.
            </QueueBannerInfoText>
            <ErrorTextArea
              onChange={(e: any) => setUserReportErrorMessage(e.target.value)}
              placeholder="Opisz swój problem"
            ></ErrorTextArea>
            {/* <QueueBannerInfoText className="alternative">
          Zostaniesz usunięta z kolejki, a powrót do obecnego pokoju nie
          będzie możliwy.
        </QueueBannerInfoText> */}
        {/* <ButtonContainer>
              <BannerButton onClick={() => handleSendBugReport()}>
                WYŚLIJ
              </BannerButton>
            </ButtonContainer>
          </QueueInfoBanner> */}
        {/* )} */}
      </ConferencesScreenContainer>
    </>
  )
}

export default MainView
